import { inject, Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivateFn, Router, RouterStateSnapshot } from '@angular/router';
import { AuthService } from '../services/auth.service';
import { Observable } from 'rxjs';
import { UserPermission } from '../enums/user-permission.enum';

@Injectable({
    providedIn: 'root',
})
class RoleGuardService {
    constructor(private authService: AuthService, private router: Router) {}

    public canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {
        return new Observable<boolean>((obs) => {
            this.authService.hasAtLeastOneRole$(route.data.roles as Array<UserPermission>).subscribe((val) => {
                if (val) {
                    obs.next(true);
                } else {
                    this.router.navigate(['dashboard/browse']).catch(console.error);
                    obs.next(false);
                }
            });
        });
    }
}

export const RoleGuard: CanActivateFn = (next: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> => {
    return inject(RoleGuardService).canActivate(next, state);
};
